/* eslint-disable import/prefer-default-export */
import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import BasicContainer from '../../../../../../../components/BasicContainer';
import { PercentageBadge } from '../../../../../../../components/shared';
import { formatNumber, formatNumberWithComma } from '../../../../../../../utilities/formatHelpers';
import { currencies } from '../../../../../../../utilities/constants';
import {
  BalanceCardPlaceholder,
  SettingButtonPlaceholder,
} from '../../../../../../../components/Placeholders';

export const LeftSide = ({
  refreshBalances,
  showStakingfeature,
  changesPercentage,
  totalBalanceInFiat,
  totalChangeInFiat,
  fiatCurrencyCode,
  coin,
  availableBalance,
  totalBXXBalance,
  stakingAmount,
  renderButtons,
  renderStakeNowBtn,
  isLoading,
}) => {
  const { t: translate } = useTranslation();

  if (isLoading) {
    return (
      <div className="d-flex flex-column gap-4">
        <BalanceCardPlaceholder />
        <SettingButtonPlaceholder />
      </div>
    );
  }

  return (
    <>
      <BasicContainer className="account-details-left-side-container">
        {/* browser layout */}
        <div className="d-none d-md-flex flex-row justify-content-between align-items-center">
          <div
            className="d-flex flex-row align-items-center"
            onClick={refreshBalances}
            onKeyDown={null}
            tabIndex={-1}
            role="button">
            <p className="text-f6 text-shadow">
              <b>
                {showStakingfeature
                  ? translate('total_balance_label')
                  : translate('available_balance_label')}
              </b>
            </p>
          </div>

          {!showStakingfeature && <PercentageBadge percentage={changesPercentage} />}
        </div>

        {/* mobile layout */}
        <div className="d-flex d-md-none flex-row mt-2 justify-content-center">
          <p
            className="text-f6 text-shadow pe-2"
            style={{ lineHeight: '1rem' }}>{`≈${formatNumberWithComma(
            totalBalanceInFiat
          )} ${fiatCurrencyCode}`}</p>
        </div>

        <p className="account-details-left-side-container-total mt-2">
          <b>
            {!showStakingfeature ? availableBalance : totalBXXBalance} {coin.toUpperCase()}
          </b>
        </p>
        <div className="d-flex flex-row mt-2 justify-content-center justify-content-md-start">
          <p className="d-none d-md-block text-f6 text-shadow pe-2">{`≈${formatNumberWithComma(
            totalBalanceInFiat
          )} ${fiatCurrencyCode}`}</p>
          <p className={`text-f6 ${totalChangeInFiat >= 0 ? 'text-success' : 'text-danger'}`}>
            {totalChangeInFiat >= 0 ? '+' : ''}
            {totalChangeInFiat} {fiatCurrencyCode} (24h.)
          </p>
        </div>
        {showStakingfeature && (
          <div className="mt-4">
            <p className="text-f6 text-shadow text-center text-md-start">
              <b>{translate('available_balance_label')}</b>
            </p>
            <p className="account-details-left-side-container-total mt-2">
              <b>
                {availableBalance} {coin.toUpperCase()}
              </b>
            </p>
          </div>
        )}
        {showStakingfeature && (
          <div className="mt-4 text-center text-md-start">
            <p className="text-shadow text-f6">{translate('in_staking_label')}</p>
            <p className="text-dark text-bold mt-1">{`${formatNumberWithComma(
              formatNumber(stakingAmount * currencies[coin].conversion, currencies[coin].decimal)
            )} ${coin?.toUpperCase()}`}</p>
          </div>
        )}
        <div className="pt-2">{renderButtons()}</div>
      </BasicContainer>
      {showStakingfeature && renderStakeNowBtn()}
    </>
  );
};

LeftSide.propTypes = {
  refreshBalances: PropTypes.func.isRequired,
  showStakingfeature: PropTypes.bool.isRequired,
  changesPercentage: PropTypes.number.isRequired,
  totalBalanceInFiat: PropTypes.number.isRequired,
  totalChangeInFiat: PropTypes.number.isRequired,
  fiatCurrencyCode: PropTypes.string.isRequired,
  coin: PropTypes.string.isRequired,
  availableBalance: PropTypes.number.isRequired,
  totalBXXBalance: PropTypes.number.isRequired,
  stakingAmount: PropTypes.number.isRequired,
  renderButtons: PropTypes.func.isRequired,
  renderStakeNowBtn: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
};

LeftSide.defaultProps = {
  isLoading: true,
};
